import { inject, injectable } from 'inversify';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ClientTypes as CommonTypes } from '@common-stack/client-core';
import { CacheTypenames, IContextMenuService, IContextMenu_input, IActionRun_input } from '@workbench-stack/core';
import { ContextMenuDocument } from '@workbench-stack/components/lib/editors';

@injectable()
export class ContextMenuService implements IContextMenuService {

    constructor(
        @inject(CommonTypes.ApolloClient)
        protected client: ApolloClient<any>,
        @inject(CommonTypes.InMemoryCache)
        protected cache: InMemoryCache,
    ) {
    }

    public async showContextMenu(delegate: IContextMenu_input) {
        const data = {
            ...delegate,
            anchor: {
                ...delegate.anchor,
                height: delegate.anchor.height || null,
                width: delegate.anchor.width || null,
                __typename: CacheTypenames.Anchor,
            },
            menuItems: delegate.menuItems.map((item) => ({
                ...item,
                run: item.run ? {
                    ...item.run,
                    __typename: CacheTypenames.ActionRun,
                } : null,
                __typename: CacheTypenames.MenuItem,
            })),
            __typename: CacheTypenames.ContextMenu,
        };
        try {
            await this.client.writeQuery({
                query: ContextMenuDocument,
                data: { contextMenu: data },
            });
            return true;
        } catch (e) {
            console.error(e);
            return false;
        }
    }

    public async hideContextMenu() {
        const data = {
            id: null,
            isShow: false,
            anchor: {
                x: 0,
                y: 0,
                height: null,
                width: null,
                __typename: CacheTypenames.Anchor,
            },
            menuItems: [],
            __typename: CacheTypenames.ContextMenu,
        };
        try {
            await this.client.writeQuery({
                query: ContextMenuDocument,
                data: { contextMenu: data },
            });
            return true;
        } catch (e) {
            console.error(e);
            return false;
        }
    }

    public async runMenuAction(argument: IActionRun_input) {
        if (!argument) {
            return true;
        }
        try {
            switch (argument.type) {
                case 'query':
                    await this.client.query({
                        query: argument.document,
                        variables: argument.variables,
                    });
                    break;
                case 'mutation':
                    await this.client.mutate({
                        mutation: argument.document,
                        variables: argument.variables,
                    });
                    break;
                default:
                    console.warn('Nothing to execute.');
                    break;
            }
            return true;
        } catch (e) {
            console.error('Error:', e);
            return false;
        }
    }
}
